import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h2 className='mt-4'>Please Checkout</h2>

            <button className='btn  custom-btn fs-5 mt-3 mb-2'>Place Order</button>
        </div>
    );
};

export default Checkout;